<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="managerDefaultAudit" slot-scope="scope">
        <el-tag
          type="danger"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.managerDefaultAudit == 2"
          >拒绝访客进入</el-tag
        >
        <el-tag
          type="success"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.managerDefaultAudit == 1"
          >同意访客进入</el-tag
        >
      </template>
      <template slot="householderAudit" slot-scope="scope">
        <el-tag
          type="danger"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.householderAudit == 0"
          >否</el-tag
        >
        <el-tag
          type="success"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.householderAudit == 1"
          >是</el-tag
        >
      </template>

      <template slot="managerAudit" slot-scope="scope">
        <el-tag
          type="danger"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.managerAudit == 0"
          >否</el-tag
        >
        <el-tag
          type="success"
          style="font-size: 8px;"
          size="medium"
          v-show="scope.row.managerAudit == 1"
          >是</el-tag
        >
      </template>
      <template slot="menuLeft">
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.doorauditsetting_delete"
          @click="handleDelete"
          >删 除</el-button
        >
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" size="small" @click="tip(scope.row)">
          <span class="el-icon-download"></span>二维码
        </el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  add,
  getDetail,
  getList,
  remove,
  update,
} from '@/api/v4ward/door/setting/doorauditsetting';
import { getProperty } from '@/api/common';
import { mapGetters } from 'vuex';
import qrcode from 'qrcodejs2';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        height: 'auto',
        align: 'center',
        calcHeight: 30,
        tip: false,
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        index: true,
        indexLabel: '序号',
        viewBtn: true,
        selection: false,
        dialogClickModal: false,
        labelWidth: 150,
        dialogWidth: '40%',
        column: [
          {
            label: '小区名称',
            type: 'tree',
            editDisabled: true,
            prop: 'id',
            dicUrl: '/api/base/property/tree1?objectTypeKey=1',
            search: true,
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择小区',
                trigger: 'change',
              },
            ],
          },
          {
            label: '住户是否审核',
            prop: 'householderAudit',
            slot: true,
            type: 'select',
            dicData: [
              { value: 1, label: '是' },
              { value: 0, label: '否' },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择住户是否审核',
                trigger: 'change',
              },
            ],
          },
          {
            label: '物业是否审核',
            prop: 'managerAudit',
            slot: true,
            type: 'select',
            dicData: [
              { value: 1, label: '是' },
              { value: 0, label: '否' },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择物业是否审核',
                trigger: 'change',
              },
            ],
          },
          {
            label: '物业自动审核值',
            prop: 'managerDefaultAudit',
            type: 'select',
            slot: true,
            dicData: [
              { value: 1, label: '同意访客进入' },
              { value: 2, label: '拒绝访客进入' },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择物业自动审核态度',
                trigger: 'change',
              },
            ],
          },
          {
            label: '访客开始时间',
            prop: 'openTime',
            type: 'time',
            valueFormat: 'HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请输入开始时间',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '访客截止时间',
            prop: 'closeTime',
            type: 'time',
            valueFormat: 'HH:mm:ss',
            rules: [
              {
                required: true,
                message: '请输入截止时间',
                trigger: 'blur',
              },
              {
                validator: (rule, value, callback) => {
                  //此变量无实际意义，只用于拼接开始时间和结束时间，将时间字符串转换为date 格式做比较
                  var yearDate = '2020-01-01 ';
                  var dateStart = Date.parse(yearDate + this.form.openTime);
                  var dateEnd = Date.parse(yearDate + value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('截止时间必须大于开始时间！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },
          {
            label: '物业自动审核说明',
            prop: 'managerDefualtAuditRemark',
            type: 'textarea',
            span: 24,
            maxlength: 150,
            showWordLimit: true,
            rules: [
              {
                required: true,
                message: '请输入物业不手动审核时 默认审核说明',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  activated() {
    let self = this;
    setTimeout(() => {
      self.$refs.crud.doLayout(); //解决表格错位
    }, 0);
  },
  mounted() {
    let self = this;
    setTimeout(() => {
      window.addEventListener(
        'resize',
        () => {
          self.$refs.crud.doLayout(); //窗口缩放解决表格错位
        },
        false
      );
    }, 0);
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.doorauditsetting_add, true),
        viewBtn: this.vaildData(this.permission.doorauditsetting_view, false),
        delBtn: this.vaildData(this.permission.doorauditsetting_delete, false),
        editBtn: this.vaildData(this.permission.doorauditsetting_edit, true),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
    //下载二维码图片
    tip(row) {
      console.log('row==>', row);
      var div = document.createElement('div');
      const url = `${location.origin}/wx/weixin-h5/#/visitor?communityId=${row.id}`.replace(
        /\/api/,
        ''
      );
      console.log('url==>', url);
      const fileName = row.$id;
      var code = new qrcode(div, {
        text: url,
        width: 500,
        height: 500,
        colorDark: '#000000',
        colorLight: '#ffffff',
        correctLevel: qrcode.CorrectLevel.H,
      });
      let canvas = code._el.querySelector('canvas');
      var base64Text = canvas.toDataURL('image/png');
      var blob = this.getBlob(base64Text);
      if (navigator.msSaveBlob) {
        // IE的Blob保存方法
        navigator.msSaveBlob(blob, fileName);
      } else {
        var link = document.createElement('a');
        var href = window.URL.createObjectURL(blob);
        link.href = href;
        link.download = fileName;
        document.body.appendChild(link); // firefox需要把a添加到dom才能正确执行click
        link.click();
        // 延时保证下载成功执行，否则可能下载未找到文件的问题
        setTimeout(function () {
          window.URL.revokeObjectURL(href); // 释放Url对象
          document.body.removeChild(link);
        }, 100);
      }
    },
    //下载二维码辅助方法
    getBlob(base64) {
      var mimeString = base64.split(',')[0].split(':')[1].split(';')[0]; // mime类型
      var byteString = atob(base64.split(',')[1]); //base64 解码
      var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
      var intArray = new Uint8Array(arrayBuffer); //创建视图
      for (var i = 0; i < byteString.length; i += 1) {
        intArray[i] = byteString.charCodeAt(i);
      }
      return new Blob([intArray], {
        type: mimeString,
      });
    },
  },
};
</script>

<style></style>
